'use strict';

import type { UserCommission } from '../../Entities/User/UserCommission';
import { EntityCollection } from '../EntityCollection';

export class UserCommissionCollection extends EntityCollection<UserCommission> {}
